import { Link } from 'react-router'
import { ReactSVG } from 'react-svg'

import styles from './styles.module.scss'

interface ArrowLinkProps {
  to: string;
  text?: string;
}

export default function ArrowLink (props: ArrowLinkProps) {
  const { to, text } = props

  return (
    <Link to={to} className={styles.root}>
      {text}
      <span className={styles.icon}>
        <ReactSVG className={styles.svg} src="/icons/arrow.svg" />
      </span>
    </Link>
  )
}
